<template>
    <div  >

        <!-- tabs -->
        <tq-tabs :p_selected-tab-index_vn="selectedTabIndex_vn"
                 p_att_s="name"
                 :p_tabs_ao="co_editMissionsTabs_ao"
                 :p_display_lang-code_e="p_system_langCode_e"
                 class="TQ_bg_white "
                 p_tabs-class_s="TQ_padding_8px">

            <div class="TQ_minHeight_400px">

                <!-- 1) preview -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 0" class="TQ_padding_8px">

                    <!-- 1.1) previewMode-->
                    <div>
                        <img :src="ass_img_mobile_b"
                             :class="{'TQ_bg_purple' : selectedPreviewMode_e === enum_screenSizeType.mobile}"
                             @click="selectedPreviewMode_e = enum_screenSizeType.mobile"
                             class="TQ_margin_4px TQ_width_36px TQ_bg_white TQ_padding_8px TQ_borderRadius TQ_box_shadow TQ_clickable TQ_bg_hover_purple"/>
                        <img :src="ass_img_tablet_b"
                             :class="{'TQ_bg_purple' : selectedPreviewMode_e === enum_screenSizeType.tablet_big}"
                             @click="selectedPreviewMode_e = enum_screenSizeType.tablet_big"
                             class="TQ_margin_4px TQ_width_36px TQ_bg_white TQ_padding_8px TQ_borderRadius TQ_box_shadow TQ_clickable TQ_bg_hover_purple"/>
                        <!--<img :src="ass_img_laptop_b"-->
                        <!--:class="{'TQ_bg_purple' : selectedPreviewMode_e === enum_screenSizeType.laptop}"-->
                        <!--@click="selectedPreviewMode_e = enum_screenSizeType.laptop"-->
                        <!--class="TQ_margin_4px TQ_width_36px TQ_bg_white TQ_padding_8px TQ_borderRadius TQ_box_shadow TQ_clickable TQ_bg_hover_purple"/>-->
                    </div>

                    <!-- 1.2) preview by lang code -->
                    <div class="TQ_maxWidth_full TQ_inline"
                         :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                         :key="langCode"
                         v-for="(langCode, index) in langArr">

                        <!-- lang -->
                        <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                        <!-- riddle -->
                        <tq-card  :max-width="co_previewCardMaxWidth_s" width="100vw" margin="8px" >

                            <tq-riddle-data

                                    :p_name_s="'preview_' + langCode"
                                    :p_system_lang-code_e="langCode"
                                    :p_qb_displayLangCode_e="langCode"
                                    :p_window-size_e="selectedPreviewMode_e"

                                    :p_qb_riddle_c="p_qb_riddle_c"
                                    :p_qb_metadata_c="p_metadataQB_c"

                                    :p_clues-left_n="3"
                                    :p_skips-left_n="3"

                                    :p_display-riddle-image_b="p_showEditImage_b"

                                    p_user-id_uid="123456"
                                    :p_click-get-clue_f="(clueIndex) => {}"
                                    :p_click-skip-riddle_f="(unlocksData_byLockId)=> {}"
                                    :p_update-riddle-lock-answer_f="(unlocksData_byLockId) => {}"/>
                        </tq-card>
                    </div>

                </div>

                <!-- 3) mission body -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 2" class="TQ_padding_8px">

                    <!-- 2.1) title style -->
                    <div class="TQ_margin_bottom_16px">
                        <!-- title -->
                        <div class="TQ_inline TQ_text_24px TQ_verticalAlignMiddle TQ_margin_4px lc_styleTitle TQ_text_bold">
                            {{ass_strings.twoWords_titlesStyle[p_system_langCode_e]}}:
                        </div>

                        <!-- title color -->
                        <div class="TQ_inline TQ_margin_4px TQ_verticalAlignTop">
                            <div class="TQ_text_20px"> {{ass_strings.oneWord_color[p_system_langCode_e]}}</div>
                            <input type="color" class="TQ_width_64px TQ_padding_4px" v-model="p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s"/>
                        </div>

                        <!-- background color -->
                        <div class="TQ_inline TQ_margin_4px TQ_verticalAlignTop" >
                            <div class="TQ_text_20px"> {{ass_strings.oneWord_background[p_system_langCode_e]}}</div>
                            <input type="color" class="TQ_width_64px TQ_padding_4px" v-model="p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s"/>
                        </div>

                        <!-- fontSize -->
                        <div class="TQ_inline TQ_margin_4px TQ_verticalAlignTop">

                            <div class="TQ_text_20px"> {{ass_strings.oneWord_size[p_system_langCode_e]}}</div>
                            <tq-select class="TQ_bg_white TQ_width_72px " :style-select="true" >

                                <div slot="select" class="TQ_padding_2px"> {{p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s}} </div>

                                <div    slot="options"
                                        @click="p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s = fontSize"
                                        class="TQ_dropdown_option TQ_center TQ_padding_8px"
                                        :key="'fontSize' + key"
                                        :class="{'TQ_optionSelected': p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s === fontSize}"
                                        v-for="(fontSize,key) in fontSize_px">
                                    {{fontSize}}
                                </div>
                            </tq-select>
                        </div>

                        <!-- fontSize -->
                        <div class="TQ_inline TQ_margin_4px TQ_verticalAlignTop">

                            <div class="TQ_text_20px"> {{ass_strings.oneWord_font[p_system_langCode_e]}}</div>
                            <tq-select class="TQ_bg_white TQ_width_200px " :style-select="true" >

                                <div slot="select" class="TQ_padding_2px"> {{p_qb_riddle_c.qbr_theme_c.qbrt_font_s}} </div>

                                <div    slot="options"
                                        @click="p_qb_riddle_c.qbr_theme_c.qbrt_font_s = font"
                                        class="TQ_dropdown_option TQ_center TQ_padding_8px"
                                        :key="'fontSize' + key"
                                        :class="{'TQ_optionSelected': p_qb_riddle_c.qbr_theme_c.qbrt_font_s === font}"
                                        v-for="(font,key) in ass_fonts">
                                    {{font}}
                                </div>
                            </tq-select>
                        </div>
                    </div>

                    <!-- 2.4) mission body -->
                    <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                         :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                         :key="langCode"
                         v-for="(langCode, index) in langArr">

                        <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                        <!-- image -->
                        <div class="lc_img" v-if="p_showEditImage_b" @click="m_userEvents_selectImage_f(langCode)">
                            <tq-display-file
                                    class="TQ_border"
                                    v-if="p_qb_riddle_c.qbr_imgFile_blc_c[langCode] && p_qb_riddle_c.qbr_imgFile_blc_c[langCode].fi_url_s"
                                    :file="p_qb_riddle_c.qbr_imgFile_blc_c[langCode]"
                            />
                            <div v-else class="lc_noImage TQ_center TQ_bg_white">
                                {{ass_strings.fourWords_clickToUploadImage[langCode]}}
                            </div>
                        </div>


                        <tq-card width="100%">
                            <!-- title -->
                            <input class="TQ_input TQ_input_fullScreen TQ_center"
                                   :placeholder="ass_strings.oneWord_title[langCode]"
                                   v-model="p_qb_riddle_c.qbr_title_blc_s[langCode]"
                                   :style="co_riddleTitleStyle_s"> <br>

                            <!-- subtitle-->
                            <textarea v-if="p_showEditSubtitle_b"
                                      class="TQ_input TQ_fullScreen TQ_text_16px TQ_padding_4px"
                                      :placeholder="ass_strings.oneWord_subtitle[langCode]"
                                      v-model="p_qb_riddle_c.qbr_subtitle_blc_s[langCode]"></textarea>

                            <!-- body -->
                            <tq-wysiwyg-editor id="editCardsBody"
                                            :p_value_html="p_qb_riddle_c.qbr_body_blc_c[langCode].w_body_s"
                                            :pe_update-value_f="(newValue_html) => {p_qb_riddle_c.qbr_body_blc_c[langCode].w_body_s = newValue_html}"
                                            :pe_choose-file_f="pe_chooseFile_f"/>
                        </tq-card>

                    </div>

                </div>

                <!-- 4) map section -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 6" >

                    <!-- 1.5) maps toggle -->
                    <div class="TQ_margin_8px"
                         v-if="p_metadataQB_c.qbm_missions_supportMapSection_b">
                        <div class="TQ_text_bold TQ_text_20px">{{ass_strings.twoWords_displayMap[p_system_langCode_e]}}</div>
                        <tq-toggle-switch v-model="p_qb_riddle_c.qbr_metadata_c.qbrm_mapSection_b"/>
                    </div>

                    <tq-leaflet-edit
                            v-if="p_qb_riddle_c.qbr_metadata_c.qbrm_mapSection_b"
                            class="border TQ_height_300px TQ_maxWidth_300px TQ_center"
                            :key="uid"

                            p_map-uid_s="mapid_riddleData_edit"
                            :p_map-data_c="p_qb_riddle_c.qbr_mapData_c"
                            :p_qb_metadata_c="p_metadataQB_c"

                            :p_missions-editable_b="false"
                    />

                    <div v-else class="TQ_border TQ_height_300px TQ_maxWidth_300px TQ_center TQ_text_20px lc_inactiveMapText">
                        {{ass_strings.twoWords_inactiveMap[p_system_langCode_e]}}
                    </div>
                </div>

                <!-- 5) hints -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 3" >

                    <!-- tabs -->
                    <tq-tabs :key="tqTabs_selectedClueTabIndex_vn.val"

                             :p_selected-tab-index_vn="tqTabs_selectedClueTabIndex_vn"
                             :p_display_lang-code_e="p_system_langCode_e"
                             :p_tabs_ao="p_qb_riddle_c.qbr_clues_ac"
                             p_att_s="qbrc_title_blc_s"

                             :p_system_lang-code_e="p_system_langCode_e"
                             :p_title_blc_s="ass_strings.oneWord_hints"

                             class="TQ_bg_white"
                             :style="{paddingTop: '4px'}"
                             p_padding-body_s="8px"
                             p_tabs-class_s="TQ_text_16px TQ_padding_8px"
                             :p_vertical-layout_b="true"

                             :pe_on-change-order_f="(newOrder_c) => {p_qb_riddle_c.qbr_clues_ac = newOrder_c}"
                             :pe_add-tab_click_f="v_userEvents_addClue_f"
                             :pe_delete-tab_click_f="v_userEvents_deleteClue_f"
                             :p_add-tab-text_s="ass_strings.twoWords_newHint[p_system_langCode_e]"
                             :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteHint">

                        <div class="TQ_minHeight_400px">
                            <div v-if="co_selectedClue_c">


                                <!-- clue points worth-->
                                <div v-if="[enum_cluesMode_e.points, enum_cluesMode_e.points_gradual].includes(p_metadataQB_c.qbm_missions_cluesMode_e)">
                                    <div>
                                        {{ass_strings.oneWord_points[p_system_langCode_e]}}
                                    </div>
                                    <input class="TQ_input TQ_center" v-model.number="co_selectedClue_c.qbrc_pointsWorth_n"/>
                                </div>

                                <!-- lang code-->
                                <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                                     :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                                     :key="langCode"
                                     v-for="langCode in langArr">

                                    <!-- title lang -->
                                    <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                                    <!-- clues -->
                                    <input :placeholder="ass_strings.twoWords_hintTitle[langCode]"
                                           class="TQ_input TQ_input_fullScreen TQ_center"
                                           v-model="co_selectedClue_c.qbrc_title_blc_s[langCode]"
                                           :style="co_riddleTitleStyle2_s"/>

                                    <tq-wysiwyg-editor id="'editClueBody' + clueIndex"
                                                       :file-name="uid + '_clueBody_' + langCode"
                                                       :p_value_html="co_selectedClue_c.qbrc_body_blc_c[langCode].enc_value_s"
                                                       :pe_update-value_f="(newValue_html) => {co_selectedClue_c.qbrc_body_blc_c[langCode].enc_value_s = newValue_html}"
                                                       :pe_choose-file_f="pe_chooseFile_f"
                                                       height="200px"/>



                                </div>
                            </div>
                        </div>
                    </tq-tabs>
                </div>

                <!-- 6) locks -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 4">

                    <!-- tabs -->
                    <tq-tabs :p_selected-tab-index_vn="tqTabs_selectedLockTabIndex_vn"
                             :key="tqTabs_selectedLockTabIndex_vn.val"
                             :p_display_lang-code_e="p_qb_displayLangCode_e"
                             :p_system_lang-code_e="p_system_langCode_e"

                             :p_tabs_ao="p_qb_riddle_c.qbr_locks_ac"

                             :p_title_blc_s="ass_strings.oneWord_locks"

                             p_att_s="qbrl_title_blc_s"
                             class="TQ_bg_white"
                             :style="{paddingTop: '4px'}"
                             p_tabs-class_s="TQ_text_16px TQ_padding_8px"
                             :p_vertical-layout_b="true"

                             :pe_on-change-order_f="(newOrder_c) => {p_qb_riddle_c.qbr_locks_ac = newOrder_c}"
                             :pe_add-tab_click_f="m_userEvents_addLock_f"
                             :pe_delete-tab_click_f="m_userEvents_deleteLock_f"
                             :p_add-tab-text_s="ass_strings.twoWords_newLock[p_system_langCode_e]"
                             :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteLock">

                        <div v-if="tqTabs_selectedLockTabIndex_vn.val < p_qb_riddle_c.qbr_locks_ac.length" class="TQ_padding_0px_4px">

                            <!-- 2.1) totalTime -->
                            <div v-if="[enum_lockTypes.TRIVIA].includes(co_selectedLock_c.qbrl_type_e)" class="TQ_margin_8px ">
                                <span class="TQ_text_bold TQ_text_20px">{{ass_strings.twoWords_totalTime[p_system_langCode_e]}}:</span>
                                <input type="number" :min="enum_numbers.lockTotalTimeInSeconds_min" :max="enum_numbers.lockTotalTimeInSeconds_max" step="1"
                                       class="TQ_input TQ_text_bold TQ_margin_4px TQ_text_20px"
                                       :placeholder="ass_strings.twoWords_totalTime[p_system_langCode_e]"
                                       v-model.number="co_selectedLock_c.qbrl_totalTimeInSeconds_n">
                            </div>

                            <!-- 2.2) points -->
                            <div v-if="p_metadataQB_c.qbm_missions_supportMissionsPoints_b" class="TQ_margin_8px ">

                                <!-- total points -->
                                <div class="TQ_inline TQ_margin_4px">
                                    <div class="TQ_text_bold TQ_align_initial TQ_text_14px">{{ass_strings.oneWord_points[p_system_langCode_e]}}</div>
                                    <input type="number" :min="0" step="1"
                                           class="TQ_input TQ_width_100px TQ_align_initial"
                                           :placeholder="ass_strings.oneWord_points[p_system_langCode_e]"
                                           v-model.number="co_selectedLock_c.qbrl_points_n">
                                </div>

                                <!-- min points -->
                                <div class="TQ_inline TQ_margin_4px" v-if="co_selectedLock_c.qbrl_type_e == enum_lockTypes.GPS">
                                    <div class="TQ_text_bold TQ_align_initial TQ_text_14px">{{ass_strings.twoWords_minPoints[p_system_langCode_e]}}</div>
                                    <input type="number" :min="0" step="1"
                                           class="TQ_input TQ_width_100px TQ_align_initial"
                                           :placeholder="ass_strings.oneWord_points[p_system_langCode_e]"
                                           v-model.number="co_selectedLock_c.qbrl_minPoints_n">
                                </div>

                                <!-- error cost -->
                                <div class="TQ_inline TQ_margin_4px" v-if="co_selectedLock_c.qbrl_type_e == enum_lockTypes.GPS">
                                    <div class="TQ_text_bold TQ_align_initial TQ_text_14px">{{ass_strings.twoWords_errorCost[p_system_langCode_e]}}</div>
                                    <input type="number" :min="0" step="1"
                                           class="TQ_input TQ_width_100px TQ_align_initial"
                                           :placeholder="ass_strings.oneWord_points[p_system_langCode_e]"
                                           v-model.number="co_selectedLock_c.qbrl_errorPointsCost_n">
                                </div>

                            </div>

                            <!-- lock type -->
                            <div class="TQ_padding_12px TQ_verticalAlignMiddle TQ_inline"></div>
                            <tq-select :style-select="true" class="TQ_bg_gray4 TQ_maxWidth_300px TQ_fullScreen TQ_text_24px TQ_margin_8px TQ_verticalAlignMiddle">

                                <div slot="select">

                                    <div class="TQ_grid_col_autoAuto1fr ">
                                        <div class="TQ_padding_4px"></div>
                                        <img :src="co_locksOptionsData_byLockType_o[co_selectedLock_c.qbrl_type_e].img_r" class="TQ_width_32px TQ_grid_verticalCenter TQ_bg_white TQ_borderRadius TQ_padding_4px"/>

                                        <div class="TQ_inline TQ_grid_verticalCenter">
                                            {{co_locksOptionsData_byLockType_o[co_selectedLock_c.qbrl_type_e].title_s}}
                                        </div>
                                    </div>

                                </div>

                                <div slot="options"
                                     class="TQ_bg_gray4 TQ_bg_hover_purple"
                                     @click="m_userEvents_changeLockType_f(lockType_e)"
                                     v-for="(lockData_o,lockType_e) in co_locksOptionsData_byLockType_o" :key="lockType_e">

                                    <div class="TQ_grid_col_autoAuto1fr">
                                        <div class="TQ_padding_4px"></div>
                                        <img :src="lockData_o.img_r" class="TQ_width_32px TQ_grid_verticalCenter TQ_bg_white TQ_borderRadius TQ_padding_4px"/>

                                        <div class="TQ_inline TQ_grid_verticalCenter">
                                            {{lockData_o.title_s}}
                                        </div>
                                    </div>


                                </div>
                            </tq-select>
                            <tq-more-info :p_more-info-id_uid="enum_moreInfo_helpersIds_s.helpers_edit_mission_locks" class="TQ_width_28px TQ_verticalAlignMiddle "/>
                            <br>

                            <!-- Lock: Title, Body locks-qrCode and image/video -->
                            <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                                 :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                                 :key="langCode"
                                 v-for="(langCode, langIndex) in langArr">

                                <!-- lang title-->
                                <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                                <!-- lock title and body -->
                                <tq-card width="100%" >

                                    <!-- Lock Title -->
                                    <input :placeholder="ass_strings.twoWords_lockTitle[langCode]"
                                           class="TQ_input TQ_input_fullScreen TQ_center TQ_text_16px" v-model="co_selectedLock_c.qbrl_title_blc_s[langCode]"
                                           :style="co_riddleTitleStyle2_s"/>

                                    <!-- Lock Body -->
                                    <tq-wysiwyg-editor :id="'editLockBody' + tqTabs_selectedLockTabIndex_vn.val"
                                                       :p_value_html="co_selectedLock_c.qbrl_body_blc_c[langCode].w_body_s"
                                                       :pe_update-value_f="(newValue_html) => {co_selectedLock_c.qbrl_body_blc_c[langCode].w_body_s = newValue_html}"
                                                        :pe_choose-file_f="pe_chooseFile_f"
                                                        height="200px"/>

                                </tq-card>

                                <!-- locks-->
                                <div class="TQ_margin_top_4px">

                                    <!-- IMAGE/VIDEO-->
                                    <tq-card v-if="[enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(co_selectedLock_c.qbrl_type_e) && !co_selectedLock_c.qbrl_autoApprove_b"
                                             max-width="350px" width="100%" margin="8px" padding="8px">
                                        {{ass_strings.sentence_creatorImgLock[langCode]}}
                                    </tq-card>

                                    <!-- Words/includesWords -->
                                    <tq-card v-if="[enum_lockTypes.INCLUDE_WORD, enum_lockTypes.WORDS].includes(co_selectedLock_c.qbrl_type_e)"
                                             width="100%" padding="8px" class="TQ_border">

                                        <div v-for="(encryptedAns_c, index) in co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ans_blc_ac[langCode]" >
                                            <input class="TQ_input TQ_verticalAlignMiddle TQ_margin_4px"
                                                   :placeholder="ass_strings.oneWord_answer[langCode]"
                                                   @input="m_lockWords_changeOption_f(langCode, index, encryptedAns_c.enc_value_s)"
                                                   v-model="encryptedAns_c.enc_value_s"/>
                                            <img class="TQ_width_16px TQ_bg_circle TQ_bg_gray1 TQ_verticalAlignMiddle TQ_padding_4px"
                                                 :src="ass_img_garbage_w"
                                                 @click="m_userEvent_deleteQuestionAns_f(co_selectedLock_c.qbrl_questions_ac[0], index, langCode)">
                                        </div>
                                        <div >
                                            <div @click="m_userEvent_addNewQuestionAns_f(co_selectedLock_c.qbrl_questions_ac[0], langCode)" class="TQ_btn TQ_bg_green TQ_margin_8px">
                                                <img :src="ass_img_add_w" class="TQ_width_16px TQ_verticalAlignMiddle"/>
                                            </div>
                                        </div>
\
                                        <div class="TQ_text_bold TQ_inline"> {{ass_strings.threeWords_numberOfAnswers[langCode]}}: </div>
                                        <tq-select class="TQ_select TQ_direction_ltr TQ_margin_4px" :style-select="true" :ps_only-mobile-mode_b="true">

                                            <div slot="select" class="TQ_padding_4px">
                                                {{co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansNum_blc_n[langCode]}}
                                                /
                                                {{co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ans_blc_ac[langCode].length}}
                                            </div>

                                            <div slot="options"
                                                 @click="co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansNum_blc_n[langCode] = optionsIndex_n + 1"
                                                 class="TQ_center TQ_padding_8px "
                                                 v-for="(encAns_c, optionsIndex_n) in co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ans_blc_ac[langCode]"
                                                 :class="{'TQ_optionSelected' : co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansNum_blc_n[langCode] === optionsIndex_n + 1}"
                                                 :key="optionsIndex_n">
                                                {{optionsIndex_n + 1}} /
                                                {{co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ans_blc_ac[langCode].length}}
                                            </div>
                                        </tq-select>
                                        <br>
                                    </tq-card>

                                    <!-- Options -->
                                    <tq-card v-if="[enum_lockTypes.OPTIONS].includes(co_selectedLock_c.qbrl_type_e)"
                                             width="100%" padding="8px" class="TQ_border">
                                        <div v-for="(option_c,index) in co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansOptions_blc_ac[langCode]" class="TQ_margin_4px">

                                            <tq-checkbox :p_checked_b="co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ans_blc_ac[langCode].map(enc_c => enc_c.enc_value_s).includes(option_c.enc_value_s)"
                                                         @click.native="m_userEvent_optionsChangeAns_f(co_selectedLock_c.qbrl_questions_ac[0], langCode, option_c)"
                                                         class="TQ_width_24px TQ_height_24px TQ_verticalAlignMiddle TQ_inline"/>

                                            <div class="TQ_inline TQ_padding_8px"></div>

                                            <input class="TQ_input TQ_verticalAlignMiddle TQ_center TQ_margin_4px"
                                                   v-model="co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansOptions_blc_ac[langCode][index].enc_value_s"
                                                   @input="m_userEvent_optionsChangeOptions_f(co_selectedLock_c.qbrl_questions_ac[0], langCode)"
                                                   :placeholder="ass_strings.oneWord_options[langCode]"/>

                                            <!-- space -->
                                            <div class="TQ_padding_4px TQ_inline"></div>

                                            <img class="TQ_width_16px TQ_bg_circle TQ_bg_gray1 TQ_verticalAlignMiddle TQ_padding_4px"
                                                 :src="ass_img_garbage_w"
                                                 @click="m_userEvent_deleteOption_f(co_selectedLock_c.qbrl_questions_ac[0], index, langCode)">
                                        </div>

                                        <div>
                                            <div @click="co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansOptions_blc_ac[langCode].push(m_newEnc_c())" class="TQ_btn TQ_bg_green TQ_margin_8px">
                                                <img :src="ass_img_add_w" class="TQ_width_16px TQ_verticalAlignMiddle"/>
                                            </div>
                                        </div>

                                    </tq-card>


                                </div>



                            </div><br>

                            <!-- gps location info -->
                            <div v-if="[enum_lockTypes.GPS].includes(co_selectedLock_c.qbrl_type_e)">

                                <!-- edit map -->
                                <div class="TQ_margin_8px">
                                    <tq-map-edit :p_map-data_c="co_gpsLock_mapData_c"
                                                 :p_markers_ac="co_gpsLock_markers_ac"
                                                 class="TQ_height_300px TQ_width_300px TQ_center"/>
                                </div>

                                <!-- longitude -->
                                <div class="TQ_inline TQ_margin_4px">
                                    <div class="TQ_align_initial TQ_text_12px">
                                        {{ass_strings.oneWord_longitude[p_system_langCode_e]}}
                                    </div>
                                    <input placeholder="longitude" class="TQ_padding_4px " type="number" step="0.0001" v-model.number="co_selectedLock_c.qbrl_gpsLocation_c.mp_lng_n">
                                </div>

                                <!-- latitude -->
                                <div class="TQ_inline TQ_margin_4px">
                                    <div class="TQ_align_initial TQ_text_12px">
                                        {{ass_strings.oneWord_latitude[p_system_langCode_e]}}
                                    </div>
                                    <input placeholder="latitude" class="TQ_padding_4px " type="number" step="0.0001" v-model.number="co_selectedLock_c.qbrl_gpsLocation_c.mp_lat_n">
                                </div>

                                <!-- radius -->
                                <div class="TQ_margin_4px TQ_inline">
                                    <div class="TQ_align_initial TQ_text_12px">
                                        {{ass_strings.twoWords_radiusMaters[p_system_langCode_e]}}
                                    </div>
                                    <input placeholder="radius" class="TQ_padding_4px " type="number" v-model.number="co_selectedLock_c.qbrl_gpsLocation_c.mp_radiusMaters_n">
                                </div>

                            </div>

                            <!-- image/video need to approved-->
                            <div class="TQ_margin_8px" v-if="[enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(co_selectedLock_c.qbrl_type_e)">

                                <!-- video text -->
                                <tq-dropdown class="TQ_border TQ_margin_bottom_8px" :ps_only-mobile-mode_b="true" v-if="[enum_lockTypes.VIDEO].includes(co_selectedLock_c.qbrl_type_e)">

                                    <div slot="select" class="TQ_padding_8px">
                                        {{ass_strings.sentence_videoLengthMax[p_system_langCode_e].replace("$1", co_selectedLock_c.qbrl_videoMaxTime_n)}}
                                    </div>

                                    <div slot="options">
                                        <div v-for="(val, key, index) in enum_missions_Locks_video_time"
                                             @click="co_selectedLock_c.qbrl_videoMaxTime_n = val"
                                             class="TQ_padding_8px" :key="index" :class="index >0 && 'TQ_border'">
                                            {{ass_strings.sentence_videoLengthMax[p_system_langCode_e].replace("$1", val)}}
                                        </div>
                                    </div>

                                </tq-dropdown>

                                <!-- auto approve -->
                                <div>
                                    <tq-toggle-switch class="TQ_margin_4px TQ_inline TQ_verticalAlignMiddle" v-model="co_selectedLock_c.qbrl_autoApprove_b" height="24px" width="42px" slider-width="12px" p_circle-size_s="16px"/>
                                    <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                                    <div class="TQ_text_20px TQ_text_bold TQ_inline TQ_verticalAlignMiddle TQ_margin_bottom_8px"> {{ass_strings.twoWords_automaticApprove[p_system_langCode_e]}} </div>
                                </div>

                                <!--<div>-->
                                    <!--<tq-toggle-switch class="TQ_margin_4px TQ_inline TQ_verticalAlignMiddle" v-model="co_selectedLock_c.qbrl_guideGiveScore_b" height="24px" width="42px" slider-width="12px" p_circle-size_s="16px"/>-->
                                    <!--<div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>-->
                                    <!--<div class="TQ_text_20px TQ_text_bold TQ_inline TQ_verticalAlignMiddle TQ_margin_bottom_8px"> {{ass_strings.twoWords_guideScore[p_system_langCode_e]}} </div>-->
                                <!--</div>-->

                            </div>

                            <!-- skippable -->
                            <div class="TQ_margin_8px" v-if="p_metadataQB_c.qbm_missions_supportSkips_b">
                                <tq-toggle-switch class="TQ_margin_4px TQ_inline TQ_verticalAlignMiddle" v-model="co_selectedLock_c.qbrl_skippable_b" height="24px" width="42px" slider-width="12px" p_circle-size_s="16px"/>
                                <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                                <div class="TQ_text_20px TQ_text_bold TQ_inline TQ_verticalAlignMiddle TQ_margin_bottom_8px"> {{ass_strings.twoWords_skippableLock[p_system_langCode_e]}} </div>
                            </div>

                            <!-- Quiz-->
                            <div v-if="[enum_lockTypes.QUIZ, enum_lockTypes.TRIVIA].includes(co_selectedLock_c.qbrl_type_e)">

                                <!-- title -->
                                <div class="TQ_padding_8px TQ_bg_white TQ_border_bottom TQ_text_24px TQ_text_bold TQ_bg_purple_lite ">
                                    {{ass_strings.twoWords_editQuestions[p_system_langCode_e]}}
                                </div>

                                    <!-- Questions -->
                                    <tq-tabs :p_selected-tab-index_vn="tqTabs_selectedQuizQuestionTabIndex_vn"
                                             :key="tqTabs_selectedQuizQuestionTabIndex_vn.val"
                                             :p_tabs_ao="co_selectedLock_c.qbrl_questions_ac"
                                             :p_tab-title-prefix_blc_s="ass_strings.oneWord_question"
                                             :p_display_lang-code_e="p_system_langCode_e"
                                             :p_add-tab-text_s="ass_strings.twoWords_addQuestion[p_system_langCode_e]"

                                             :p_system_lang-code_e="p_system_langCode_e"
                                             :p_title_blc_s="ass_strings.oneWord_questions"

                                             p_padding-body_s="16px"
                                             p_tabs-class_s="TQ_text_16px TQ_padding_8px"
                                             class="TQ_bg_white"
                                             :p_vertical-layout_b="true"

                                             :pe_delete-tab_click_f="m_userEvent_deleteQuizQuestion_f"
                                             :pe_add-tab_click_f="m_userEvent_addNewQuizQuestion_f"
                                             :p_delete-tab_approve-text_cla_s="ass_strings.question_deleteLockQuestion">

                                        <div v-if="tqTabs_selectedQuizQuestionTabIndex_vn.val < co_selectedLock_c.qbrl_questions_ac.length">

                                            <!-- Tq question type-->
                                            <div class="TQ_margin_bottom_8px">
                                                <tq-select :style-select="true" class="TQ_bg_white TQ_maxWidth_300px TQ_fullScreen TQ_text_20px">

                                                    <div slot="select">
                                                        {{format_lockType_fs(co_selectedQuizQuestion_c.qbrlq_type_e, p_system_langCode_e)}}
                                                    </div>

                                                    <div slot="options"
                                                         v-for="lockQuestionType_e in enum_lockQuestionsTypes"
                                                         :key="lockQuestionType_e"
                                                         :class="{'TQ_optionSelected' : co_selectedQuizQuestion_c.qbrlq_type_e === lockQuestionType_e}"
                                                         @click="co_selectedQuizQuestion_c.qbrlq_type_e = lockQuestionType_e">
                                                        {{format_lockType_fs(lockQuestionType_e, p_system_langCode_e)}}
                                                    </div>
                                                </tq-select>
                                            </div>

                                            <!--body -->
                                            <div class="TQ_inline TQ_maxWidth_320px"
                                                 :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                                                 :key="langCode"
                                                 v-for="langCode in langArr">

                                                <!-- lang title-->
                                                <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                                                <!-- question card -->
                                                <tq-card max-width="350px" width="100%" margin="8px" >

                                                    <!-- quiz lock question-->
                                                    <div class="TQ_padding_4px TQ_margin_4px">

                                                        <!-- question body -->
                                                        <tq-wysiwyg-editor :id="'editLockBody+' + tqTabs_selectedLockTabIndex_vn.val + '_' + tqTabs_selectedQuizQuestionTabIndex_vn.val"
                                                                           :p_value_html="co_selectedQuizQuestion_c.qbrlq_body_blc_c[langCode].w_body_s"
                                                                           :pe_update-value_f="(newValue_html) => {co_selectedQuizQuestion_c.qbrlq_body_blc_c[langCode].w_body_s = newValue_html}"

                                                                            :top-bar-dont-display="['addImage', 'addVideo', 'addAudio']"
                                                                            :pe_choose-file_f="pe_chooseFile_f"
                                                                            height="100px"/>

                                                        <!-- Words/includesWords -->
                                                        <div v-if="[enum_lockQuestionsTypes.INCLUDE_WORD, enum_lockQuestionsTypes.WORDS].includes(co_selectedQuizQuestion_c.qbrlq_type_e)" >

                                                            <div v-for="(encAns_c, index) in co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode]" >
                                                                <input class="TQ_input TQ_verticalAlignMiddle TQ_margin_4px"
                                                                       :placeholder="ass_strings.oneWord_answer[langCode]"
                                                                       @input="m_lockQuizWords_changeOption_f(langCode, index, encAns_c.enc_value_s)"
                                                                       v-model="encAns_c.enc_value_s"/>
                                                                <img class="TQ_width_16px TQ_bg_circle TQ_bg_gray1 TQ_verticalAlignMiddle TQ_padding_4px"
                                                                     :src="ass_img_garbage_w"
                                                                     @click="m_userEvent_deleteQuestionAns_f(co_selectedQuizQuestion_c, index, langCode)">
                                                            </div>
                                                            <div >
                                                                <div @click="m_userEvent_addNewQuestionAns_f(co_selectedQuizQuestion_c, langCode)" class="TQ_btn TQ_bg_green TQ_margin_8px">
                                                                    <img :src="ass_img_add_w" class="TQ_width_16px TQ_verticalAlignMiddle"/>
                                                                </div>
                                                            </div>

                                                            <div class="TQ_text_bold TQ_inline"> {{ass_strings.threeWords_numberOfAnswers[langCode]}}: </div>
                                                            <tq-select class="TQ_select TQ_direction_ltr TQ_margin_4px" :style-select="true">

                                                                <div slot="select" class="TQ_padding_4px">
                                                                    {{co_selectedQuizQuestion_c.qbrlq_ansNum_blc_n[langCode]}}
                                                                    /
                                                                    {{co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode].length}}
                                                                </div>

                                                                <div slot="options"
                                                                     @click="co_selectedQuizQuestion_c.qbrlq_ansNum_blc_n[langCode] = optionsIndex_n + 1"
                                                                     class="TQ_center TQ_padding_8px "
                                                                     v-for="(ans, optionsIndex_n) in co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode]"
                                                                     :class="{'TQ_optionSelected' : co_selectedQuizQuestion_c.qbrlq_ansNum_blc_n[langCode] === optionsIndex_n + 1}"
                                                                     :key="optionsIndex_n">
                                                                    {{optionsIndex_n + 1}} /
                                                                    {{co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode].length}}
                                                                </div>
                                                            </tq-select>
                                                            <br>
                                                        </div>

                                                        <!-- Options -->
                                                        <div v-if="[enum_lockQuestionsTypes.OPTIONS].includes(co_selectedQuizQuestion_c.qbrlq_type_e)" >
                                                            <div v-for="(option_c,index) in co_selectedQuizQuestion_c.qbrlq_ansOptions_blc_ac[langCode]" class="TQ_margin_4px">
                                                                <!--<input type="checkbox"-->
                                                                <!--       class="TQ_verticalAlignMiddle TQ_input"-->
                                                                <!--       :value="option_c"-->
                                                                <!--       v-model="co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode].enc_value_s"-->
                                                                <!--       @change="m_userEvent_optionsChangeAns_f(co_selectedQuizQuestion_c, langCode)"/>-->

                                                                <tq-checkbox :p_checked_b="co_selectedQuizQuestion_c.qbrlq_ans_blc_ac[langCode].map(enc_c => enc_c.enc_value_s).includes(option_c.enc_value_s)"
                                                                             @click.native="m_userEvent_optionsChangeAns_f(co_selectedQuizQuestion_c, langCode, option_c)"
                                                                             class="TQ_width_20px TQ_height_20px TQ_verticalAlignMiddle TQ_inline"/>

                                                                <div class="TQ_inline TQ_padding_8px"></div>


                                                                <input class="TQ_input TQ_verticalAlignMiddle TQ_center TQ_margin_4px"
                                                                       v-model="co_selectedQuizQuestion_c.qbrlq_ansOptions_blc_ac[langCode][index].enc_value_s"
                                                                       @input="m_userEvent_optionsChangeOptions_f(co_selectedQuizQuestion_c, langCode)"
                                                                       :placeholder="ass_strings.oneWord_options[langCode]"/>

                                                                <div class="TQ_padding_4px TQ_inline"></div><!-- space -->

                                                                <img class="TQ_width_16px TQ_bg_circle TQ_bg_gray1 TQ_verticalAlignMiddle TQ_padding_4px"
                                                                     :src="ass_img_garbage_w"
                                                                     @click="m_userEvent_deleteOption_f(co_selectedQuizQuestion_c, index, langCode)">
                                                            </div>
                                                            <div>
                                                                <div @click="co_selectedQuizQuestion_c.qbrlq_ansOptions_blc_ac[langCode].push(m_newEnc_c())" class="TQ_btn TQ_bg_green TQ_margin_8px">
                                                                    <img :src="ass_img_add_w" class="TQ_width_16px TQ_verticalAlignMiddle"/>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </tq-card>

                                            </div>

                                            <!-- question caseSensitive -->
                                            <div class="TQ_margin_8px TQ_text_20px">
                                                <input type="checkbox" v-model="co_selectedQuizQuestion_c.qbrlq_caseSensitive_b">
                                                {{ass_strings.twoWords_caseSensitive[p_system_langCode_e]}}
                                            </div>

                                        </div>

                                        <div v-else class="TQ_minHeight_200px"></div>

                                    </tq-tabs>

                            </div>

                        </div>

                        <div v-else class="TQ_minHeight_200px"></div>

                    </tq-tabs>
                </div>

                <!-- 5) last section -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 5" class="TQ_minHeight_200px">

                    <!-- 1.3) finishSection toggle  -->
                    <div class="TQ_margin_8px" v-if="p_metadataQB_c.qbm_missions_supportFinishSection_b">
                        <div class="TQ_text_bold TQ_text_20px">{{ass_strings.threeWords_displayFinishSection[p_system_langCode_e]}}</div>
                        <tq-toggle-switch v-model="p_qb_riddle_c.qbr_metadata_c.qbrm_finishSection_b"/>
                    </div>

                    <!-- lang code-->
                    <div class="TQ_inline TQ_maxWidth_320px TQ_margin_8px"
                         :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
                         v-if="p_qb_riddle_c.qbr_metadata_c.qbrm_finishSection_b"
                         :key="langCode"
                         v-for="(langCode, index) in langArr">

                        <!-- title lang -->
                        <div class="TQ_text_24px"> {{format_langCode_fs(langCode)}}</div>

                        <tq-wysiwyg-editor id="editCardsBody"
                                           :p_value_html="p_qb_riddle_c.qbr_finishSection_blc_c[langCode].w_body_s"
                                           :pe_update-value_f="(newValue_html) => {p_qb_riddle_c.qbr_finishSection_blc_c[langCode].w_body_s = newValue_html}"
                                            height="300px"
                                            :pe_choose-file_f="pe_chooseFile_f"
                                            :full="true"/>
                    </div>
                </div>

                <!-- 7) settings -->
                <div v-if="co_editMissionsTabs_ao[selectedTabIndex_vn.val].id === 7" class="TQ_minHeight_200px">

                    <!-- skippable -->
                    <div class="TQ_margin_8px TQ_padding_16px">
                        <tq-toggle-switch class="TQ_margin_4px TQ_inline TQ_verticalAlignMiddle"
                                          v-model="p_qb_riddle_c.qbr_metadata_c.qbrm_displayLocksInOrder_b" height="24px" width="42px" slider-width="12px" p_circle-size_s="16px"/>
                        <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_text_20px TQ_text_bold TQ_inline TQ_verticalAlignMiddle TQ_margin_bottom_8px"> {{ass_strings.fourWords_displayLocksInOrder[p_system_langCode_e]}} </div>
                    </div>
                </div>

            </div>
        </tq-tabs>
    </div>
</template>

<script>
    import TqWysiwygEditor from "./TqWysiwygEditor";
    import TqToggleSwitch from "../basic/TqToggleSwitch";
    import {
        enum_cluesMode_e,
        enum_featuresMinPoints,
        enum_lockQuestionsTypes,
        enum_missions_Locks_video_time,
        enum_moreInfo_featuresIds_s,
        enum_moreInfo_helpersIds_s,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {format_lockType_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import TqCard from "../basic/TqCard";
    import {
        helper_arrToObj_fo,
        helper_getDirectionByLangCode_fe, helper_getFbClassSize_s,
    } from "@/scripts/S_Helper";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqSelect from "../basic/TqDropdown";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import TqDisplayFile from "../mediaComponenets/TqDisplayFile";
    import TqLeafletEdit from "../maps/TqLeafletEdit";
    import {
        ass_img_add_w,
        ass_img_garbage_w,
        ass_img_lock_w,
        ass_img_laptop_b,
        ass_img_mobile_b,
        ass_img_tablet_b,
        ass_img_lockQuiz_b,
        ass_img_lockIncludeText_b,
        ass_img_lockOptions_b,
        ass_img_QrCode_b,
        ass_img_lockVideo_b,
        ass_img_lockImage_b,
        ass_img_lockText_b,
        ass_img_info2_b,
        ass_img_lockTimer_b,
        ass_img_svg_fullscreen_b, ass_img_location
    } from "@/assets/scripts/Ass_Files";
    import {gv_fonts} from "@/scripts/S_GlobalVar";
    import TqToggleDiv from "../basic/TqToggleDiv";
    import TqTabs from "../basic/TqTabs";
    import TqRiddleData from "./TqRiddleData";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {obj_map_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import {date_setTimeout} from "@/scripts/S_Date";
    import {format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {
        enum_fileType,
        enum_langCodes,
        enum_lockTypes,
        enum_screenSizesOptions_n
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        FB_EncryptValue, FB_MapData, FB_MapPoint,
        FB_QuestBody_Metadata, FB_QuestBody_Riddle, FB_QuestBody_Riddle_Lock_Question,
        FB_UserData
    } from "../../../functions/src/shareCode/Share_S_Classes";
    import TqCheckbox from "@/components/basic/TqCheckbox";
    import {re_startAndEndWith_s} from "@/scripts/S_RegularExp";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f, serverAuth_getOtherUserData_f
    } from "@/scripts/Server/S_ServerAuth";
    import TqMoreInfo from "@/components/basic2/TqMoreInfo";
    import TqDropdown from "@/components/basic/TqDropdown";
    import TqLeafletDisplaySimple from "@/components/maps/TqLeafletDisplaySimple";
    import TqMapEdit from "@/components/maps/TqMapEdit";

    export default {
        name: "TqRiddleData_Edit",
        components:{
            TqMapEdit,
            TqLeafletDisplaySimple,
            TqDropdown,
            TqMoreInfo,
            TqCheckbox,
            TqOnTopContainer,
            TqRiddleData,
            TqTabs,
            TqToggleDiv,
            TqLeafletEdit,
            TqDisplayFile,
            TqSelect,
            TqCard,
            TqToggleSwitch,
            TqWysiwygEditor,
        },
        props: {

            // basic
            uid : {
                type: String,
                require: true
            },
            p_creatorId_uid:{
                require: true,
                type: String
            },
            p_creatorActivePaymentPlan_b:{
                type: Boolean,
                require: true
            },
            langArr:{
                type: Array,
                require: true
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_qb_displayLangCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },

            // main
            p_qb_riddle_c: {
                type:FB_QuestBody_Riddle,
                require:true
            },
            p_metadataQB_c:{
                type: FB_QuestBody_Metadata,
                require: true,
            },

            // others
            p_cardsMissions_b : {
                type: Boolean,
                default : false
            },
            p_showEditImage_b : {
                type: Boolean,
                default : false
            },
            p_showEditSubtitle_b : {
                type: Boolean,
                default : false
            },
            p_imageWidthAndHeight_o : {
                type: Object,
                default() {
                    return {
                        height: 300,
                        width : 400,
                    }
                }
            },
            pe_chooseFile_f: {
                type: Function,
                require: true,
            }

        },
        data(){
            return{

                editSectionIndex_n : null,

                fontSize_px: ['24px', '32px', '40px', '48px', '56px'],
                selectedTabIndex_vn : {val :0},
                tqTabs_selectedLockTabIndex_vn : {val :0},
                tqTabs_selectedClueTabIndex_vn : {val :0},
                tqTabs_selectedQuizQuestionTabIndex_vn : {val :0},

                selectedPreviewMode_e  : enum_screenSizesOptions_n.mobile,

                // === imports ====
                ass_fonts: gv_fonts,

                enum_lockTypes          : enum_lockTypes,
                enum_lockQuestionsTypes : enum_lockQuestionsTypes,
                enum_cluesMode_e        : enum_cluesMode_e,
                enum_numbers            : gv_numbers,
                enum_fileType           : enum_fileType,
                enum_screenSizeType     : enum_screenSizesOptions_n,
                enum_moreInfo_helpersIds_s     : enum_moreInfo_helpersIds_s,
                enum_missions_Locks_video_time     : enum_missions_Locks_video_time,

                ass_strings         : ass_strings,
                ass_img_garbage_w   : ass_img_garbage_w,
                ass_img_add_w       : ass_img_add_w,
                ass_img_lock_white  : ass_img_lock_w,
                ass_img_mobile_b    : ass_img_mobile_b,
                ass_img_tablet_b    : ass_img_tablet_b,
                ass_img_laptop_b    : ass_img_laptop_b,
                ass_img_info2_b    : ass_img_info2_b,

                format_lockType_fs                  : format_lockType_fs,
                format_langCode_fs                  : format_langCode_fs,
                helper_getDirectionByLangCode_fe    : helper_getDirectionByLangCode_fe,
                helper_getFbClassSize_s             : helper_getFbClassSize_s,
            }
        },
        computed : {
            co_previewCardMaxWidth_s (){

                switch(this.selectedPreviewMode_e){
                    case enum_screenSizesOptions_n.mobile:
                        return gv_numbers.mobileRegularWidth + 'px';
                    case enum_screenSizesOptions_n.tablet_big:
                        return gv_numbers.tabletRegularWidth + 'px';
                    case enum_screenSizesOptions_n.laptop:
                        return null;
                }
            },
            co_editMissionsTabs_ao(){

                let ans = [
                    {name: ass_strings.twoWords_preview,         id : 0},
                    {name: ass_strings.twoWords_missionBody,     id : 2},

                ]

                if(this.p_metadataQB_c.qbm_missions_supportMapSection_b){
                    ans.push({name: ass_strings.twoWords_innerMap,       id : 6})
                }

                if(this.p_metadataQB_c.qbm_missions_cluesMode_e !== enum_cluesMode_e.none){
                    ans.push({name: ass_strings.oneWord_hints,          id : 3})
                }

                ans.push({name: ass_strings.oneWord_locks,           id : 4})
                ans.push({name: ass_strings.twoWords_lastSection,    id : 5})
                ans.push({name: ass_strings.oneWord_settings,        id : 7})


                return ans
            },
            co_riddleTitleStyle_s(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s
                }
            },
            co_riddleTitleStyle2_s(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : 'calc(' + this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s + ' - 8px)'
                }
            },
            co_selectedLock_c(){
                return this.p_qb_riddle_c.qbr_locks_ac[this.tqTabs_selectedLockTabIndex_vn.val]
            },
            co_selectedClue_c(){
                return this.p_qb_riddle_c.qbr_clues_ac[this.tqTabs_selectedClueTabIndex_vn.val]
            },
            co_selectedQuizQuestion_c(){
                return this.co_selectedLock_c.qbrl_questions_ac[this.tqTabs_selectedQuizQuestionTabIndex_vn.val]
            },
            co_locksOptionsData_byLockType_o() {

                return {
                    [enum_lockTypes.WORDS]          : {title_s: ass_strings.oneWord_text[this.p_system_langCode_e], img_r: ass_img_lockText_b},
                    [enum_lockTypes.OPTIONS]        : {title_s: ass_strings.oneWord_options[this.p_system_langCode_e], img_r: ass_img_lockOptions_b},
                    [enum_lockTypes.INCLUDE_WORD]   : {title_s: ass_strings.twoWords_includesWord[this.p_system_langCode_e], img_r: ass_img_lockIncludeText_b},
                    [enum_lockTypes.QUIZ]           : {title_s: ass_strings.oneWord_quiz[this.p_system_langCode_e], img_r: ass_img_lockQuiz_b},
                    [enum_lockTypes.GPS]            : {title_s: ass_strings.oneWord_gps[this.p_system_langCode_e], img_r: ass_img_location},
                    [enum_lockTypes.IMAGE]          : {title_s: ass_strings.oneWord_image[this.p_system_langCode_e], img_r: ass_img_lockImage_b},
                    [enum_lockTypes.VIDEO]          : {title_s: ass_strings.oneWord_video[this.p_system_langCode_e], img_r: ass_img_lockVideo_b},
                }

            },
            co_dom_titleStyle_s(){
                return {
                    background  : this.p_qb_riddle_c.qbr_theme_c.qbrt_backgroundColor_s,
                    fontFamily  : this.p_qb_riddle_c.qbr_theme_c.qbrt_font_s,
                    color       : this.p_qb_riddle_c.qbr_theme_c.qbrt_textColor_s,
                    fontSize    : this.p_qb_riddle_c.qbr_theme_c.qbrt_textSize_s
                }
            },
            co_gpsLock_mapData_c(){
                return new FB_MapData({
                    md_center_c : this.co_selectedLock_c.qbrl_gpsLocation_c
                })
            },
            co_gpsLock_markers_ac(){
                return [this.co_selectedLock_c.qbrl_gpsLocation_c]
            }
        },
        methods:{

            // qr code
            m_newEnc_c(){
                return new FB_EncryptValue('')
            },

            // ======= userEvents =========

            // locks
            m_userEvents_changeLockType_f(lockType){
                this.co_selectedLock_c.qbrl_type_e = lockType

                switch (lockType){

                    case enum_lockTypes.VIDEO:
                    case enum_lockTypes.IMAGE:
                        this.co_selectedLock_c.qbrlq_ansNum_blc_n = obj_map_fo(this.langArr, (item)=>{ return 1});
                        break;
                    case enum_lockTypes.OPTIONS:
                        this.co_selectedLock_c.qbrl_questions_ac = [new FB_QuestBody_Riddle_Lock_Question({qbrlq_type_e : enum_lockQuestionsTypes.OPTIONS})]
                        break;
                    case enum_lockTypes.INCLUDE_WORD:
                        this.co_selectedLock_c.qbrl_questions_ac = [new FB_QuestBody_Riddle_Lock_Question({qbrlq_type_e : enum_lockQuestionsTypes.INCLUDE_WORD})]
                        break;
                    case enum_lockTypes.WORDS:
                        this.co_selectedLock_c.qbrl_questions_ac = [new FB_QuestBody_Riddle_Lock_Question({qbrlq_type_e : enum_lockQuestionsTypes.WORDS})]
                        break;

                }

            },
            m_userEvents_addLock_f(){

                // title
                let title_blc_s = helper_arrToObj_fo(this.langArr, (langCode) => {
                    return `${ass_strings.oneWord_lock[langCode]} ${this.p_qb_riddle_c.qbr_locks_ac.length + 1}`
                })

                // add new lock
                this.p_qb_riddle_c.cm_qbr_addNewLock_f(title_blc_s, this.langArr)

                // move to created lock
                this.tqTabs_selectedLockTabIndex_vn.val = this.p_qb_riddle_c.qbr_locks_ac.length - 1

            },
            m_userEvents_deleteLock_f(lockIndex_n){

                let arrSize_n =  this.p_qb_riddle_c.qbr_locks_ac
                if(this.tqTabs_selectedQuizQuestionTabIndex_vn.val === arrSize_n - 1 && arrSize_n > 1){
                    this.tqTabs_selectedLockTabIndex_vn.val =  arrSize_n - 2
                }
                this.p_qb_riddle_c.qbr_locks_ac.splice(lockIndex_n,1)
            },
            v_userEvents_addClue_f(){

                let title_blc_s = helper_arrToObj_fo(this.langArr, (langCode) => {
                    return `${ass_strings.oneWord_hint[langCode]} ${this.p_qb_riddle_c.qbr_clues_ac.length + 1}`
                })

                this.p_qb_riddle_c.cm_qbr_addNewClue_f(title_blc_s, this.langArr)

                this.tqTabs_selectedClueTabIndex_vn.val = this.p_qb_riddle_c.qbr_clues_ac.length - 1

            },
            v_userEvents_deleteClue_f(clueIndex_n){
                this.p_qb_riddle_c.qbr_clues_ac.splice(clueIndex_n,1)
            },
            m_lockWords_changeOption_f(langCode_e, index_n, newValue_s){
                this.co_selectedLock_c.qbrl_questions_ac[0].qbrlq_ansOptions_blc_ac[langCode_e][index_n] = new FB_EncryptValue(newValue_s)
            },
            m_lockQuizWords_changeOption_f(langCode_e, index_n, newValue_s){
                this.co_selectedQuizQuestion_c.qbrlq_ansOptions_blc_ac[langCode_e][index_n] = new FB_EncryptValue(newValue_s)
            },

            // questions
            m_userEvent_addNewQuizQuestion_f(){
                this.co_selectedLock_c.qbrl_questions_ac.push(new FB_QuestBody_Riddle_Lock_Question({}))

                this.tqTabs_selectedQuizQuestionTabIndex_vn.val = this.co_selectedLock_c.qbrl_questions_ac.length -1
            },
            m_userEvent_deleteQuizQuestion_f(questionIndex_n){

                let arrSize_n =  this.co_selectedLock_c.qbrl_questions_ac
                if(this.tqTabs_selectedQuizQuestionTabIndex_vn.val === arrSize_n - 1 && arrSize_n > 1){
                    this.tqTabs_selectedQuizQuestionTabIndex_vn.val =  arrSize_n - 2
                }

                this.co_selectedLock_c.qbrl_questions_ac.splice(questionIndex_n, 1)
            },
            m_userEvent_addNewQuestionAns_f(qbrl_questions_c, langCode){

                qbrl_questions_c.qbrlq_ans_blc_ac[langCode].push(new FB_EncryptValue(''))
                // qbrl_questions_c.qbrlq_ansOptions_blc_ac[langCode].push(new FB_EncryptValue(''))
                // qbrl_questions_c.qbrlq_ans_blc_as[langCode].push('')
                // qbrl_questions_c.qbrlq_m_updateAns_f(langCode, null, '')

            },
            m_userEvent_deleteQuestionAns_f(qbrl_question_c, ansIndex_n, langCode){

                let value = qbrl_question_c.qbrlq_ans_blc_ac[langCode][ansIndex_n].enc_value_s
                let ansOptions_as = qbrl_question_c.qbrlq_ansOptions_blc_ac[langCode].map(enc_c => enc_c.enc_value_s)
                let qbrlq_optionIndex_n = ansOptions_as.indexOf(value)

                qbrl_question_c.qbrlq_ans_blc_ac[langCode].splice(ansIndex_n, 1)
                if(qbrlq_optionIndex_n > -1)
                    qbrl_question_c.qbrlq_ansOptions_blc_ac[langCode].splice(qbrlq_optionIndex_n, 1)
            },
            m_userEvent_deleteOption_f(qbrl_question_c, optionIndex_n, langCode_e){

                let value_s = qbrl_question_c.qbrlq_ansOptions_blc_ac[langCode_e][optionIndex_n].enc_value_s
                let ans_as = qbrl_question_c.qbrlq_ans_blc_ac[langCode_e].map(enc_c => enc_c.enc_value_s)

                let indexAnsArr = ans_as.indexOf(value_s)

                qbrl_question_c.qbrlq_ansOptions_blc_ac[langCode_e].splice(optionIndex_n, 1)
                if(indexAnsArr > -1)
                    qbrl_question_c.qbrlq_ans_blc_ac[langCode_e].splice(indexAnsArr, 1)

                qbrl_question_c.qbrlq_ansNum_blc_n[langCode_e] = qbrl_question_c.qbrlq_ans_blc_ac[langCode_e].length
            },
            m_userEvent_optionsChangeAns_f(qbrl_question_c, langCode, option_c){

                let indexOf_n = qbrl_question_c.qbrlq_ans_blc_ac[langCode].map(enc_c => enc_c.enc_value_s).indexOf(option_c.enc_value_s)
                if(indexOf_n > -1){
                    qbrl_question_c.qbrlq_ans_blc_ac[langCode].splice(indexOf_n,1)
                } else{
                    qbrl_question_c.qbrlq_ans_blc_ac[langCode].push(option_c)
                }         

                qbrl_question_c.qbrlq_ansNum_blc_n[langCode] = qbrl_question_c.qbrlq_ans_blc_ac[langCode].length
            },
            m_userEvent_optionsChangeOptions_f(qbrl_question_c, langCode){

                qbrl_question_c.qbrlq_ans_blc_ac[langCode] = qbrl_question_c.qbrlq_ans_blc_ac[langCode]
                    .filter((item) => {
                        return qbrl_question_c.qbrlq_ansOptions_blc_ac[langCode].map(enc_c => enc_c.enc_value_s).includes(item.enc_value_s)
                    })

                qbrl_question_c.qbrlq_ansNum_blc_n[langCode] = qbrl_question_c.qbrlq_ans_blc_ac[langCode].length
            },

            // svg
            m_userEvents_selectImage_f(langCode_e){


                this.pe_chooseFile_f(file_c => {
                    this.p_qb_riddle_c.qbr_imgFile_blc_c[langCode_e] = file_c
                })
            },

        },
    }

</script>


<style scoped lang="scss">

    textarea{
        resize: none;
        overflow: hidden;
    }

    .lc_styleTitle {
        vertical-align: bottom;
    }


    .lc_img{
        padding: 10px 50px;
        .lc_noImage {
            text-align: center;
            line-height: 170px;
            border: 1px solid;
            width: 200px;
            cursor: pointer;
            margin-bottom: 4px;
            border-radius: 2px;
        }

        img {
            width: 200px;
            border: 1px solid;
        }
    }


    .lc_inactiveMapText{
        line-height: 300px;
    }

</style>    